import { Link } from "react-router-dom";
import { Phone, Printer, Mail, MapPin, Clock } from "lucide-react";
import { CONTACT, HOURS } from "../data/site";

const exploreLinks = [
  { to: "/services", label: "Services" },
  { to: "/eyewear", label: "Eyewear" },
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact" },
];

const FooterBrand = () => (
  <div className="md:col-span-1">
    <span className="font-serif text-2xl font-semibold">Brodheadsville</span>
    <p className="text-[11px] uppercase tracking-[0.35em] text-tiffany font-medium mb-4">
      Eye Care
    </p>
    <p className="text-sm text-white/60 leading-relaxed">
      An optical practice proudly serving our community with
      comprehensive eye care and designer eyewear.
    </p>
    <span className="inline-block mt-5 text-xs font-medium text-tiffany border border-tiffany/40 rounded-full px-3 py-1">
      Accepting New Patients
    </span>
  </div>
);

const FooterExplore = () => (
  <div>
    <h4 className="text-sm font-semibold uppercase tracking-widest text-white/80 mb-4">
      Explore
    </h4>
    <ul className="space-y-2.5 text-sm text-white/60">
      {exploreLinks.map((l) => (
        <li key={l.to}>
          <Link
            to={l.to}
            data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            className="hover:text-tiffany transition-colors"
          >
            {l.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

const FooterContact = () => (
  <div>
    <h4 className="text-sm font-semibold uppercase tracking-widest text-white/80 mb-4">
      Contact
    </h4>
    <ul className="space-y-3 text-sm text-white/60">
      <li className="flex items-start gap-3">
        <MapPin size={16} className="text-tiffany mt-0.5 shrink-0" />
        <a
          href={CONTACT.directionsUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-directions-link"
          className="hover:text-tiffany"
        >
          {CONTACT.addressLine1}<br />{CONTACT.addressLine2}
        </a>
      </li>
      <li className="flex items-center gap-3">
        <Phone size={16} className="text-tiffany shrink-0" />
        <a href={CONTACT.phoneHref} className="hover:text-tiffany">{CONTACT.phone}</a>
      </li>
      <li className="flex items-center gap-3">
        <Printer size={16} className="text-tiffany shrink-0" />
        <span>Fax: {CONTACT.fax}</span>
      </li>
      <li className="flex items-center gap-3">
        <Mail size={16} className="text-tiffany shrink-0" />
        <a href={CONTACT.emailHref} className="hover:text-tiffany break-all">{CONTACT.email}</a>
      </li>
    </ul>
  </div>
);

const HOURS_ICON_SIZE = 13;

const FooterHours = () => (
  <div>
    <h4 className="text-sm font-semibold uppercase tracking-widest text-white/80 mb-4">
      Office Hours
    </h4>
    <ul className="space-y-1.5 text-sm text-white/60">
      {HOURS.map((h) => (
        <li key={h.day} className="flex justify-between gap-4">
          <span className="flex items-center gap-2">
            <Clock size={HOURS_ICON_SIZE} className="text-tiffany/70" /> {h.day}
          </span>
          <span className="text-white/80">{h.time}</span>
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy text-white">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
      <FooterBrand />
      <FooterExplore />
      <FooterContact />
      <FooterHours />
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-white/40">
        <span>© {new Date().getFullYear()} {CONTACT.name}. All rights reserved.</span>
        <span>Proudly serving Brodheadsville, PA</span>
      </div>
    </div>
  </footer>
);

export default Footer;
